import { CONNECTED_SITES_CATEGORY } from '@rsos/constants/dataTypeCategories';

const categoriesToGroupBy = [CONNECTED_SITES_CATEGORY];

export const mapCategoryToName = category => {
  const mapper = {
    [CONNECTED_SITES_CATEGORY]: 'Connected Sites',
  };
  return mapper[category] || '';
};
export const groupByCategory = layers => {
  const grouped = {};
  layers.forEach(layer => {
    if (!grouped[layer.category]) {
      grouped[layer.category] = {
        id: layer.category,
        name: mapCategoryToName(layer.category),
        itemized: false /** can be used when there are categories where we want to itemize all checkboxes
        and it looks more like an accordion instead of collapsing them all into 1 checkbox
        this can be a util function that can trigger a new handling for those groups when needed */,
        layers: [],
      };
    }
    grouped[layer.category].layers.push(layer);
  });

  return grouped;
};

export const getGroupedlayers = (spatialLayers = []) => {
  const layersWithApprovedCategories = spatialLayers.filter(i =>
    categoriesToGroupBy.includes(i.category),
  );

  return groupByCategory(layersWithApprovedCategories);
};
